import { useTranslation } from 'react-i18next';
import z from 'zod';

export const useMfaSetupDialogValidationSchema = () => {
  const { t } = useTranslation();

  const mfaSetupValidationSchema = z.object({
    code: z
      .string()
      .trim()
      .min(1, t('validation:required'))
      .min(6, t('validation:codeTooShort'))
      .max(6, t('validation:codeTooLong')),
  });

  return mfaSetupValidationSchema;
};

export type MfaSetupFormValues = z.infer<
  ReturnType<typeof useMfaSetupDialogValidationSchema>
>;
